import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { KpiEditorSchemaInput } from '@/features/projects/create-project/validation/kpi-editor-schema';

export type CreateProjectStep =
  | 'projectInfo'
  | 'selectBranch'
  | 'createKpi'
  | 'kpiSummary'
  | 'addUsers'
  | 'addUsersOverview'
  | 'submitting';

export function getStepIndex(step: CreateProjectStep) {
  switch (step) {
    case 'projectInfo':
      return 0;
    case 'selectBranch':
      return 1;
    case 'createKpi':
      return 2;
    case 'kpiSummary':
      return 2;
    case 'addUsers':
      return 3;
    case 'addUsersOverview':
      return 3;
    case 'submitting':
      return 4;
  }
}

export type CreateProjectStoreData = {
  projectName?: string;
  projectDescription?: string;
  date?: DateRange;
  selectedCategory?: string;
  kpis?: KpiEditorSchemaInput[];
  memberIdsToInvite?: string[];
  step?: CreateProjectStep;
};

type CreateProjectStore = {
  step: CreateProjectStep;
  data: CreateProjectStoreData;
  setData: (data: CreateProjectStoreSetData) => void;
  reset: () => void;
};

export type CreateProjectStoreSetData = Omit<
  CreateProjectStore['data'],
  'date'
> & {
  date?: { startDate: Date; endDate: Date };
};

const initialData: CreateProjectStoreData = {
  projectName: '',
  projectDescription: '',
  date: undefined,
  selectedCategory: undefined,
  kpis: [],
  memberIdsToInvite: [],
};

export const useCreateProjectStore = create<CreateProjectStore>((set) => ({
  step: 'projectInfo',
  data: initialData,
  setData: (data) => {
    return set((state) => {
      const { date, ...rest } = data;

      return {
        data: {
          ...state.data,
          ...rest,
          date: date
            ? { from: date.startDate, to: date.endDate }
            : state.data.date,
          kpis: data.kpis || state.data.kpis,
          memberIdsToInvite:
            data.memberIdsToInvite || state.data.memberIdsToInvite,
          step: data.step || state.data.step,
        },
        step: data.step || state.step,
      };
    });
  },
  reset: () =>
    set({
      step: 'projectInfo',
      data: initialData,
    }),
}));
